import { StyleSheet } from 'react-native';

const ImagePlaceholderStyles = StyleSheet.create({
	placeholder: {
		position: 'absolute',
		left: 0,
		top: 0,
	},
	full: { width: '100%', height: '100%' },
	imageWrapper: {
		flex: 1,
	},
});
export default ImagePlaceholderStyles;
